<template>
  <div>
    <Navbar 
      :isLoggedIn="isAuthenticated"
      @show-signin="showSignIn"
      @show-signup="showSignUp"
      @sign-out="logout"
      @show-home="showHome"
      @showFeedback="openFeedbackModal"
       />
    <Home v-if="screen === 'home'" :isLoggedIn="isAuthenticated" @show-signin="showSignIn" @show-signup="showSignUp"
      @show-manual-points="showManualPoints"/>
    <SignUp v-if="screen === 'signup'" @submit-signup="showPasswordEntry" @check-passwords-match="checkPasswordsMatch"
    @show-home="showHome" @show-forgot-password="showForgotPassword"
    @show-check-email="showCheckYourEmail" />
    <CheckYourEmail v-if="screen === 'checkYourEmail'" :email="userEmail" @show-home="showHome" />
    <SignIn v-if="screen === 'signin'" @show-home="showHome" @show-forgot-password="showForgotPassword" @show-manual-points="showManualPoints" @show-check-email="showCheckYourEmail"/>
    <PasswordEntry v-if="screen === 'passwordEntry'" :form="form" :passwordsMatch="passwordsMatch"
      @submit-password="showConfirmSignup" @check-passwords-match="checkPasswordsMatch"
      @show-confirm-signup="showConfirmSignup" @show-home="showHome" />
    <ConfirmSignupView v-if="screen === 'confirmSignup'" :form="form" @show-home="showHome"
      @return-to-password-entry="showPasswordEntry" />
    <ForgotPassword v-if="screen === 'forgotPassword'" :email="forgotPasswordEmail" @show-home="showHome" />
    <ManualPointsView v-if="screen === 'manualPoints' && userHasSubscription" @show-home="showHome" />
    <DrawPointsUpgradeView v-if="screen === 'manualPoints' && !userHasSubscription" @show-home="showHome" />
    <GiveFeedback v-if="showGiveFeedback" @close="closeFeedbackModal" />
  </div>
</template>



<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Navbar from "./Navbar.vue";
import Home from "./Home.vue";
import GiveFeedback from './GiveFeedback.vue'
import SignUp from "./SignUp.vue";
import SignIn from "./SignIn.vue";
import PasswordEntry from "./PasswordEntry.vue";
import ConfirmSignupView from "./ConfirmSignupView.vue";
import ForgotPassword from "./ForgotPassword.vue";
import ManualPointsView from "./ManualPointsView.vue";
import DrawPointsUpgradeView from "./DrawPointsUpgradeView.vue";
import CheckYourEmail from "./CheckYourEmail.vue";

export default {
  name: "AppEncapsulated",
  components: {
    Navbar,
    Home,
    GiveFeedback,
    SignUp,
    SignIn,
    PasswordEntry,
    ConfirmSignupView,
    ForgotPassword,
    ManualPointsView,
    DrawPointsUpgradeView,
    CheckYourEmail,
  },
  data() {
    return {
      screen: "home", // Possible values: 'home', 'signup', 'passwordEntry', 'confirmSignup', 'checkYourEmail'
      form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        country: "USA",
        state: "",
        city: "",
        address1: "",
        address2: "",
        zip: "",
        phone: "",
        dateOfBirth: "",
        password: "",
        verifyPassword: "",
      },
      states: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      passwordsMatch: true,
      showGiveFeedback: false,
      forgotPasswordEmail: "",
      userEmail: "",
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "hasActiveSubscription"]),
    // Safe subscription check with fallback
    userHasSubscription() {
      try {
        return this.hasActiveSubscription || false;
      } catch (error) {
        console.warn('Error checking subscription status:', error);
        return false;
      }
    }
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fetchSavedHunts();
        }
      }
    }
  },
  created() {
    // Check for signin and signup query parameters
    const urlParams = new URLSearchParams(window.location.search);
    console.log("URL params:", urlParams);
    if (urlParams.get('signin') === 'true') {
      this.showSignIn();
      
      // Remove query parameters after processing
      if (window.history.pushState) {
        console.log("Removing query parameters");
        console.log("Current URL:", window.location.pathname);
        const newUrl = window.location.pathname;
        window.history.pushState({ path: newUrl }, '', newUrl);
      }
    } else if (urlParams.get('signup') === 'true') {
      this.showSignUp();
      
      // Remove query parameters after processing
      if (window.history.pushState) {
        const newUrl = window.location.pathname;
        window.history.pushState({ path: newUrl }, '', newUrl);
      }
    } else if (urlParams.get('emailNotVerified') === 'true') {
      // User was redirected due to unverified email, fetch their email and show check email page
      this.fetchUserEmailAndShowCheckEmail();
      
      // Remove query parameters after processing
      if (window.history.pushState) {
        const newUrl = window.location.pathname;
        window.history.pushState({ path: newUrl }, '', newUrl);
      }
    }
    
    // Debug auth state
    console.log("AppEncapsulated created - Auth state:", this.isAuthenticated);
  },
  mounted() {
    // Debug auth state on mount
    console.log("AppEncapsulated mounted - Auth state:", this.isAuthenticated);
  },
  methods: {
    ...mapActions(["login", "logout", "fetchSavedHunts"]),
    showSignUp() {
      this.screen = "signup";
    },
    showSignIn() {
      this.screen = "signin";
    },
    showHome() {
      this.screen = "home";
    },
    showPasswordEntry() {
      this.screen = "passwordEntry";
    },
    showForgotPassword() {
      console.log("forgotPassword");
      this.screen = "forgotPassword";
    },
    showConfirmSignup() {
      this.screen = "confirmSignup";
    },
    showManualPoints() {
      this.screen = "manualPoints"
    },
    showCheckYourEmail(email) {
      this.userEmail = email;
      this.screen = "checkYourEmail";
    },
    checkPasswordsMatch() {
      this.passwordsMatch = this.form.password === this.form.verifyPassword;
    },
    openFeedbackModal() {
      this.showGiveFeedback = true
    },
    closeFeedbackModal() {
      this.showGiveFeedback = false
    },
    async fetchUserEmailAndShowCheckEmail() {
      try {
        const response = await fetch(process.env.VUE_APP_API_BASE_URL + '/api/customers/whoami', {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const userData = await response.json();
          // Show check email page with user's email
          this.showCheckYourEmail(userData.email || '');
        } else {
          console.error('Failed to fetch user data for email verification');
          // If we can't get user email, just show the home page
          this.showHome();
        }
      } catch (error) {
        console.error('Error fetching user email:', error);
        // If we can't get user email, just show the home page
        this.showHome();
      }
    }
  },
};
</script>
